export interface IUserDisplayOptions {
    showCompanyInfos: boolean;
    showAccounts: boolean;
    hidePreviousYear: boolean;
    showCoverSheet: boolean;
    showCompanyLogo: boolean;
    showUIDonCover: boolean;
    showTableOfContents: boolean;
    showNotesInDetailInToc: boolean;
    disableBalanceSheetPageBreak: boolean;
    showDecimalPlaces: boolean;
    showEmptyLines: boolean;
    showFliTotal: boolean;
    showGroupHeaders: boolean;
    showGroupTotals: boolean;
    showFcp: boolean;
    showAop: boolean;
    showCfs: boolean;
    showNotes: boolean;
    showComplementaryReports: boolean;
    showEms: boolean;
    showFas: boolean;
    printInGrayscale: boolean;
    showCustomPageNumbers: boolean;
    startAtPage?: string;
    mainTitle: string;
    subtitle: string;
    dateTitle: string;
    showReClassInSums: boolean;
    showAdjustmentInSums: boolean;
    showRatios: boolean;
    showShareholderInformation: boolean;
    incomeItemNameForCalculatingRatio: string | null;
    showAccountNumbers: boolean;
    showAccountProofForBalance: boolean;
    showAccountProofForIncome: boolean;
    aopHideDecimalPlacesValues: boolean;
    aopHideDecimalPlacesRatios: boolean;
    aopHideEmptyLines: boolean;
    notesHideDecimalPlacesValues: boolean;
    notesHideDecimalPlacesRatios: boolean;
    notesHideEmptyLines: boolean;
    /** FX (REV-21512): print BS/ER with the display-currency twin columns (FX reports only). */
    fxShowStatementDisplayColumns: boolean;
    finStatementHideDecimalPlacesValues: boolean;
    finStatementHideDecimalPlacesRatios: boolean;
    finStatementHideEmptyLines: boolean;
    /** REV-22111: print the section's monetary values in thousands ("in TCHF"). */
    finStatementRoundToThousands: boolean;
    notesRoundToThousands: boolean;
    aopRoundToThousands: boolean;
    nonBreakingHyphen: boolean;
    applyGroupingMasking: boolean;
    showReportCompanyLogo: boolean;
    repeatAppendixTitle: boolean;
}
